import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PaymentService } from '../../../../../core/services/payment.service';
import { PaymentDialogData } from '../../../../pages/apps/lists/contacts/_subs/payment-info/payment-info.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LayoutUtilsService, MessageType } from '../../../../../core/_base/crud';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kt-create-payment-dialog',
  templateUrl: './create-payment-dialog.component.html',
  styleUrls: ['./create-payment-dialog.component.scss'],
})
export class CreatePaymentDialogComponent implements OnInit, OnDestroy {
  form: FormGroup;
  checkNumber: FormControl;
  createPaymentDialogSubscription: Subscription;

  constructor(
    public dialogRef: MatDialogRef<CreatePaymentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PaymentDialogData,
    private paymentService: PaymentService,
    private fb: FormBuilder,
    private layoutUtilsService: LayoutUtilsService,
  ) {
    this.checkNumber = new FormControl('', [
      Validators.required,
      Validators.pattern('^([0-9]){16}$'),
    ]);
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      amount: ['', [Validators.required, Validators.pattern('^[0-9]+((.|,)[0-9]{1,2}$)?$')]],
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onPayClick() {
    const controls = this.form.controls;
    if (this.form.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    if (this.isBank() && this.checkNumber.invalid) {
      this.checkNumber.markAsTouched();
      return;
    }
    this.createPaymentDialogSubscription = this.paymentService
      .createTransaction({
        amount: this.form.controls.amount.value,
        check_number: this.data.paymentType === 'UC' ? '' : this.checkNumber.value,
        customer_number: this.data.customerNumber,
      })
      .subscribe(
        (res) => {
          // const json = JSON.parse(res);
          this.layoutUtilsService.showActionNotification(
            res['ErrorMessage'] === '' ? 'Payment Accepted' : res['ErrorMessage'],
            MessageType.Read,
            3000,
            false,
            false,
          );
          this.dialogRef.close();
        },
        (err) => {
          this.layoutUtilsService.showActionNotification(
            err.error.errors[0].details,
            MessageType.Read,
            3000,
            false,
            false,
          );
          this.dialogRef.close();
        },
      );
  }

  get amount() {
    return this.form.get('amount');
  }

  isBank() {
    return this.data.paymentType === 'UA';
  }

  getErrorMessage(controlName: string, validationType: string) {
    if (this.isBank()) {
      switch (validationType) {
        case 'required':
          return this.checkNumber.hasError('required') ? 'field required' : '';
        case 'pattern':
          return this.checkNumber.hasError('pattern') ? 'must be 16 number exactly' : '';
        case 'patternAmount':
          return this.form.get(controlName)?.hasError('pattern')
            ? 'only two decimal digits allowed'
            : '';
      }
    }
    switch (validationType) {
      case 'required':
        return this.form.get(controlName).hasError('required') ? 'field required' : '';
      case 'pattern':
        return this.form.get(controlName).hasError('pattern') ? 'only 4 digit numbers' : '';
      case 'patternAmount':
        return this.form.get(controlName).hasError('pattern')
          ? 'only two decimal digits allowed'
          : '';
    }
  }

  ngOnDestroy() {
    this.createPaymentDialogSubscription?.unsubscribe();
  }
}
